/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateProfileCategoryYearDto
 */
export interface CreateUpdateProfileCategoryYearDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateProfileCategoryYearDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateProfileCategoryYearDto
     */
    year: number;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateProfileCategoryYearDto
     */
    purchasesFinancialAccount: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateProfileCategoryYearDto
     */
    salesFinancialAccount: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateProfileCategoryYearDto
     */
    commissionFinancialAccount: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateProfileCategoryYearDto
     */
    profileCategoryId: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateProfileCategoryYearDto
     */
    active: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateProfileCategoryYearDto
     */
    internal?: boolean;
}

/**
 * Check if a given object implements the CreateUpdateProfileCategoryYearDto interface.
 */
export function instanceOfCreateUpdateProfileCategoryYearDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "year" in value;
    isInstance = isInstance && "purchasesFinancialAccount" in value;
    isInstance = isInstance && "salesFinancialAccount" in value;
    isInstance = isInstance && "commissionFinancialAccount" in value;
    isInstance = isInstance && "profileCategoryId" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function CreateUpdateProfileCategoryYearDtoFromJSON(json: any): CreateUpdateProfileCategoryYearDto {
    return CreateUpdateProfileCategoryYearDtoFromJSONTyped(json, false);
}

export function CreateUpdateProfileCategoryYearDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateProfileCategoryYearDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'year': json['year'],
        'purchasesFinancialAccount': json['purchasesFinancialAccount'],
        'salesFinancialAccount': json['salesFinancialAccount'],
        'commissionFinancialAccount': json['commissionFinancialAccount'],
        'profileCategoryId': json['profileCategoryId'],
        'active': json['active'],
        'internal': !exists(json, 'internal') ? undefined : json['internal'],
    };
}

export function CreateUpdateProfileCategoryYearDtoToJSON(value?: CreateUpdateProfileCategoryYearDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'year': value.year,
        'purchasesFinancialAccount': value.purchasesFinancialAccount,
        'salesFinancialAccount': value.salesFinancialAccount,
        'commissionFinancialAccount': value.commissionFinancialAccount,
        'profileCategoryId': value.profileCategoryId,
        'active': value.active,
        'internal': value.internal,
    };
}

